<div class="w-100 dropdown-container">
  @if (isRequired) {
    @if (label) {
      <label class="dropdown-label" Asterisk>{{ label }}</label>
    }
  }
  @if (!isRequired) {
    @if (label) {
      <label class="dropdown-label">{{ label }}</label>
    }
  }
  <ng-select
    appendTo="body"
    class="dropdown-main"
    [clearable]="clearable"
    [items]="optionList"
    [multiple]="multiple"
    [closeOnSelect]="closeOnSelect"
    [searchable]="searchable"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [placeholder]="placeholder"
    [notFoundText]="notFoundText"
    [clearSearchOnAdd]="clearSearchOnAdd"
    [clearOnBackspace]="clearOnBackspace"
    [readonly]="readonly"
    [hideSelected]="hideSelected"
    [deselectOnClick]="deselectOnClick"
    [maxSelectedItems]="maxSelectedItems"
    [dropdownPosition]="dropdownPosition"
    [(ngModel)]="model"
    (ngModelChange)="onModelChange()"
    (add)="onAdd($event)"
    (blur)="onBlur($event)"
    (change)="onChange($event)"
    (close)="onClose($event)"
    (clear)="onClear($event)"
    (focus)="onFocus($event)"
    (search)="onSearch($event)"
    (open)="onOpen($event)"
    (remove)="onRemove($event)"
    (scroll)="onScroll($event)"
    (scrollToEnd)="onScrollToEnd($event)">
  </ng-select>
</div>
